// B-134 — the pure half of an office's "Máquina GLORY" switch (Oficinas and the closing detail).
//
// Off, the office is no longer asked for its GLORY export and its arqueo is the signed manual count;
// on, the GLORY is asked for and read. The backend keeps the switch and every change
// (`listCierreOfficeGlory`, `saveCierreOfficeGlory`); this file says it in words and builds what is
// sent. Turning it off needs a reason: "Sin máquina" or "Máquina dañada" as they are, "Otro" with
// the reason written.
import { fechaHoraBogota } from "./cierrePanel";

export const MOTIVOS_GLORY = Object.freeze([
  { codigo: "NO_MACHINE", etiqueta: "Sin máquina", ayuda: "La oficina no tiene máquina GLORY." },
  { codigo: "MACHINE_BROKEN", etiqueta: "Máquina dañada", ayuda: "Tiene máquina, pero no funciona." },
  { codigo: "OTHER", etiqueta: "Otro", ayuda: "Escribe el motivo." },
]);

export const MAX_DETALLE_GLORY = 500;

const etiquetaDe = (codigo) => MOTIVOS_GLORY.find((m) => m.codigo === codigo)?.etiqueta || "Apagada";

/** The reason an office's GLORY is off, as the chip beside the switch says it. Null when it is on. */
export function etiquetaMotivo(estado) {
  if (!estado || estado.gloryEnabled !== false) return null;
  if (estado.reasonCode === "OTHER") return estado.note ? `Otro: ${estado.note}` : "Otro";
  return etiquetaDe(estado.reasonCode);
}

/** Who changed it last and when — "Carga inicial" for the operator's list the migration loaded. */
export function firmaCambio(estado) {
  if (!estado?.changedBy) return "";
  const autor = estado.changedBy === "migration" ? "Carga inicial" : `por ${estado.changedBy}`;
  return estado.changedAt ? `${autor} · ${fechaHoraBogota(estado.changedAt)}` : autor;
}

/** Whether "Apagar GLORY" may be sent: a reason chosen, and for "Otro" one written. */
export function motivoValido({ reasonCode, note }) {
  if (!MOTIVOS_GLORY.some((m) => m.codigo === reasonCode)) return false;
  return reasonCode !== "OTHER" || String(note || "").trim() !== "";
}

/** What `saveCierreOfficeGlory` is sent. The detail is only "Otro"'s; turning it on, the note is optional. */
export function cambioDeGlory({ encender, reasonCode, note }) {
  const texto = String(note || "").trim();
  if (encender) return texto ? { enabled: true, note: texto } : { enabled: true };
  return reasonCode === "OTHER" ? { enabled: false, reasonCode, note: texto } : { enabled: false, reasonCode };
}

/** The line the screen says once a change is saved. */
export function avisoDeCambio(oficina, enabled) {
  const nombre = oficina?.officeName ? `${oficina.officeName} (${oficina.officeCode})` : oficina?.officeCode || "la oficina";
  return `GLORY de ${nombre} ${enabled ? "encendida" : "apagada"}. Aplica desde la próxima evaluación.`;
}

/** One entry of an office's history, in words. */
export function entradaDeHistorial(cambio) {
  const encendida = cambio.enabled === true;
  return {
    titulo: encendida ? "Encendida" : `Apagada · ${etiquetaDe(cambio.reasonCode)}`,
    tono: encendida ? "encendida" : "apagada",
    detalle: cambio.note || "",
    autor: cambio.changedBy === "migration" ? "Carga inicial (lista del operador)" : cambio.changedBy || "",
    cuando: cambio.changedAt ? fechaHoraBogota(cambio.changedAt) : "",
  };
}
